import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en.json';
import koTranslations from './locales/ko.json';

// 번역 리소스 초기화
const resources = {
  en: {
    translation: enTranslations,
  },
  ko: {
    translation: koTranslations,
  },
};

// 지원하는 언어 목록
export const supportedLanguages = [ 'en', 'ko' ];

// i18n 초기화
if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: 'ko', // 서버 사이드 렌더링 시 기본 언어는 항상 'en'으로 설정
      fallbackLng: 'ko', // 번역이 없을 경우 영어로 폴백
      interpolation: {
        escapeValue: false, // React에서는 이미 XSS 방지가 되어 있음
      },
      react: {
        useSuspense: false, // Suspense 관련 문제 방지
      },
      // SSR 관련 설정 추가
      initImmediate: false, // 즉시 초기화 (SSR에 중요)
    });
}

// 클라이언트 사이드에서 언어 설정을 변경하는 코드는
// useTranslation 훅의 useEffect에서 처리하도록 변경
// 이렇게 하면 하이드레이션 에러를 방지할 수 있습니다.

export default i18n;
